import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOMeta from '@/components/feature/SEOMeta';
import Breadcrumb from '@/components/feature/Breadcrumb';
import VideoCard from '@/components/base/VideoCard';
import { categories, videos } from '@/mocks/videos';

export default function CategoryPage() {
  const { categoryName } = useParams<{ categoryName: string }>();
  const currentCat = categories.find((c) => c.slug === categoryName) || categories[0];

  const filteredVideos =
    currentCat.slug === 'all'
      ? videos
      : videos.filter((v) => v.category === currentCat.slug);

  const breadcrumbItems = [
    { label: '首页', to: '/' },
    { label: currentCat.name },
  ];

  return (
    <>
      <SEOMeta
        title={`${currentCat.name} - 草莓视频在线播放 | 高清流畅免费看`}
        description={`草莓视频在线播放${currentCat.name}频道，提供海量${currentCat.name}类高清视频资源，无需下载即可流畅观看。草莓视频在线播放,草莓视频高清在线播放,草莓视频免费在线观看。`}
        keywords={`草莓视频在线播放,草莓视频${currentCat.name}在线播放,${currentCat.name}在线观看,草莓视频高清在线播放,在线视频播放平台`}
        canonicalUrl={`https://www.caomei-sp.com/category/${categoryName}`}
        ogTitle={`${currentCat.name} - 草莓视频在线播放`}
        ogDescription={`草莓视频在线播放${currentCat.name}频道，提供海量${currentCat.name}类高清视频资源。`}
        ogUrl={`https://www.caomei-sp.com/category/${categoryName}`}
      />
      <ScrollToTop />
      <Navbar />

      <main className="pt-16">
        <div className="bg-background-100 py-6 md:py-8">
          <div className="w-full px-4 md:px-6">
            <Breadcrumb items={breadcrumbItems} />
            <h1 className="text-2xl md:text-3xl font-heading text-foreground-900 mt-2">
              {currentCat.name}
            </h1>
            <p className="text-sm text-foreground-500 mt-1">
              共 {filteredVideos.length} 部作品 · 草莓视频在线播放
            </p>
          </div>
        </div>

        <div className="w-full px-4 md:px-6 py-6">
          <div className="flex items-center gap-2 overflow-x-auto pb-2 flex-wrap">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  currentCat.slug === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${cat.icon} text-sm`}></i>
                </div>
                {cat.name}
              </Link>
            ))}
          </div>
        </div>

        <section className="py-6 md:py-8 bg-background-50">
          <div className="w-full px-4 md:px-6">
            {filteredVideos.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-product-shop="">
                {filteredVideos.map((video) => (
                  <VideoCard key={video.id} {...video} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-secondary-100">
                  <i className="ri-inbox-line text-2xl text-secondary-500"></i>
                </div>
                <p className="text-foreground-500">该分类暂无内容，请浏览其他分类</p>
                <Link
                  to="/category/all"
                  className="inline-block mt-4 px-5 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  查看全部
                </Link>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}